import { render, staticRenderFns } from "./DepartmentManagement.vue?vue&type=template&id=69eafd17&scoped=true"
import script from "./DepartmentManagement.vue?vue&type=script&lang=js"
export * from "./DepartmentManagement.vue?vue&type=script&lang=js"
import style0 from "./DepartmentManagement.vue?vue&type=style&index=0&id=69eafd17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69eafd17",
  null
  
)

export default component.exports